<tlk-modal-header header>
	{{ headerKey | translate }}
	<button tlkButton variant="ghost" size="l" right-icon (click)="cancel()">✕</button>
</tlk-modal-header>
<tlk-modal-content content>
	<div class="warning-banner" *ngIf="duplicateError">
		<tlk-banner type="warning">
			<div tlkBannerBody class="tlk-banner__body">{{ 'PatientEditor.DuplicateWarning' | translate }}</div>
		</tlk-banner>
	</div>
	<div class="editor-form">
		<div class="field-row">
			<tlk-text-input [label]="'PatientEditor.FirstName' | translate" [required]="true" [(ngModel)]="form.firstName" name="firstName"></tlk-text-input>
			<tlk-text-input [label]="'PatientEditor.LastName' | translate" [required]="true" [(ngModel)]="form.lastName" name="lastName"></tlk-text-input>
		</div>
		<div class="field-row">
			<rx-dob-input
				[label]="'PatientEditor.DateOfBirth' | translate"
				[required]="isInvisalignMode"
				[value]="parsedDateOfBirth"
				(valueChange)="onDobChanged($event)"
				translationPrefix="PatientEditor">
			</rx-dob-input>
			<div class="gender-field">
				<span class="gender-label">{{ 'PatientEditor.Gender' | translate }}<span class="required" *ngIf="isInvisalignMode">*</span></span>
				<div class="gender-radios">
					<tlk-radio-group [(ngModel)]="form.gender" name="editorGender">
						<tlk-radio-button value="Male" [label]="'PatientEditor.Male' | translate"></tlk-radio-button>
						<tlk-radio-button value="Female" [label]="'PatientEditor.Female' | translate"></tlk-radio-button>
					</tlk-radio-group>
				</div>
			</div>
		</div>
		<div class="field-row">
			<tlk-text-input [label]="'PatientEditor.ChartNumber' | translate" [(ngModel)]="form.chartNumber" name="chartNumber"></tlk-text-input>
			<div class="field-spacer"></div>
		</div>
	</div>
</tlk-modal-content>
<tlk-modal-footer footer>
	<ng-container ngProjectAs="[right-buttons]">
		<button tlkButton variant="secondary" size="m" (click)="cancel()">{{ 'PatientEditor.Back' | translate }}</button>
		<button tlkButton variant="primary" size="m" (click)="save()" [disabled]="!isValid">{{ 'PatientEditor.Save' | translate }}</button>
	</ng-container>
</tlk-modal-footer>
